import React from 'react'
import { Steps, Button, message } from 'antd'
import injectSheet from 'react-jss'
import moment from 'moment';
import WrappedRegistrationForm from '../components/DiscountsGeneralForm'
import DiscountsConditionForm from '../components/DiscountsConditionForm'
import DiscountsDiscountForm from '../components/DiscountsDiscountForm'
import API from '../../../services/API'

const styles = {
    stepsContent: {
        margin: 16,
    },
}

const { Step } = Steps

// eslint-disable-next-line no-unused-vars
const steps = [
    {
        title: 'First',
        content: <WrappedRegistrationForm />,
    },
    {
        title: 'Second',
        content: 'Second-content',
    },
    {
        title: 'Last',
        content: 'Last-content',
    },
]

const INITIAL_STATE = {
    name: {
        value: '',
    },
    description: {
        value: '',
    },
    priority: {
        value: 1,
    },
    type: {
        value: '',
    },
    apply_to: {
        value: null,
    },
    items_to_apply: {
        value: [],
    },
    subsidiaries: [],
    customer_types: [],
    last_sync: moment().valueOf(),
}

class DiscountsEditContainer extends React.Component {
    constructor(props) {
        super(props)
        const { id } = props.match.params;
        this.id = id;
        this.state = {
            current: 0,
            data: INITIAL_STATE,
            simplePercentage: undefined,
            customDiscounts: [],
            isLoading: true,
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        const BogoOptions = [
            {
                label: 'Mismo producto',
                key: 'same_product',
            },
            {
                label: 'Otro producto',
                key: 'other_product',
            },
        ];
        API.get(`/api/discounts/${this.id}?include[]=subsidiaries&include[]=customerTypes`)
            .then((response) => {
                // console.log('Este es el response: ', response.data);
                // eslint-disable-next-line prefer-const
                let ranges = [];
                if (response.data.discount_range) {
                    // eslint-disable-next-line prefer-const
                    let discount_range_keys = Object.keys(response.data.discount_range);
                    // eslint-disable-next-line no-plusplus
                    for (let index = 0; index < discount_range_keys.length; index++) {
                        const key = discount_range_keys[index];
                        let found = {
                            key: '',
                            label: '',
                        }
                        if (response.data.discount_range[key].discount_bogo_option !== '') {
                            found = BogoOptions.find((g) => g.key === response.data.discount_range[key].discount_bogo_option);
                        }
                        if (response.data.discount_range[key].discount_bogo_product && response.data.discount_range[key].discount_bogo_product.length !== 0) {
                            response.data.discount_range[key].discount_bogo_product = response.data.discount_range[key].discount_bogo_product.map((g) => ({
                                key: g.id,
                                label: g.name,
                            }))
                        }
                        ranges.push({
                            ...response.data.discount_range[key],
                            discount_bogo_option: found,
                            discount_typeError: '',
                            discount_bogo_productError: '',
                            discount_bogo_optionError: '',
                            discount_bogo_percentError: '',
                            discount_bogo_quantityError: '',
                            minError: '',
                            maxError: '',
                            valueError: '',
                        });
                    }
                }
                let applyTo = '';
                if (response.data.apply_to) {
                    applyTo = response.data.apply_to;
                }

                // El wizard (pasos "Condición" y "Descuento") lee data.type/data.apply_to
                // como objetos { value } (la convención de campos de Ant Design), pero el
                // API los regresa como strings planos. El backend además guarda todo lo
                // creado por este wizard como type "mixed" (ver validateAndBuildMixedPayload),
                // así que para la UI ese tipo siempre corresponde al flujo "quantity_based".
                const wizardType = response.data.type === 'mixed' ? 'quantity_based' : response.data.type;

                // Sección 3 (Descuento): reconstruye el estado del wizard con lo que
                // el backend arma en default_discount / custom_discounts (ver show() de
                // DiscountsController), para que "Editar" cargue lo guardado.
                let simplePercentage;
                if (response.data.default_discount && response.data.default_discount.value !== undefined) {
                    simplePercentage = response.data.default_discount.value;
                }
                let customDiscountKeyCounter = 0;
                const customDiscounts = (response.data.custom_discounts || []).map((custom) => {
                    customDiscountKeyCounter += 1;
                    return {
                        key: customDiscountKeyCounter,
                        selectedProducts: custom.selected_products || [],
                        discountKind: custom.discount_kind,
                        percentageValue: custom.percentage_value,
                        rangeMin: custom.range_min,
                        rangeMax: custom.range_max,
                        rangeDiscountType: custom.range_discount_type || 'percentage',
                        rangeValue: custom.range_value,
                    };
                });

                const toState = {
                    // eslint-disable-next-line react/no-unused-state
                    ranges,
                    data: {
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        ...this.state.data,
                        ...response.data,
                        type: { value: wizardType },
                        apply_to: { value: applyTo },
                        last_sync: moment().valueOf(),
                    },
                    simplePercentage,
                    customDiscounts,
                    isLoading: false,
                }
                this.setState(toState);
                // const { setFieldsValue } = this.props.form
            })
            .catch((err) => {
                console.error('Error get discounts', err);
            });
    }

    next = () => {
        if (this.state.current === 2) {
            this.toSave();
            return
        }
        // eslint-disable-next-line react/no-access-state-in-setstate
        const current = this.state.current + 1
        this.setState({ current })
    }

    prev = () => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const current = this.state.current - 1
        this.setState({ current })
    }

    onFieldChange = (changedFields) => {
        this.setState(({ data }) => ({
            data: {
                ...data,
                ...changedFields,
            },
        }))
    }

    toSave = async () => {
        const { data, simplePercentage, customDiscounts } = this.state;
        this.setState({
            // eslint-disable-next-line react/no-unused-state
            isLoading: true,
        });
        // eslint-disable-next-line prefer-const
        let toSend = {
            priority: data.priority.value,
            name: data.name.value,
            description: data.description.value,
            type: data.type.value,
            // date_from: null,
            // date_to: null,

            // product, category, brand
            // apply_to: data.apply_to.value,
            // items_to_apply: this.props.items_to_apply,

            // discount_range: this.props.discount_range,
            // item_based_condition: this.props.item_based_condition,
            // item_based_discount: this.props.item_based_discount,
            // items_to_exclude: this.props.items_to_exclude,

            // buy_type: data.buy_type.value,
            // items_to_apply_count_option: data.items_to_apply_count_option.value,
            // items_to_apply_count: data.items_to_apply_count.value,
            // quantity_rule: data.quantity_rule.value,
            // quantity_from: data.quantity_from.value,
        }

        if (data && data.date_from && data.date_from.value) {
            toSend.date_from = moment(data.date_from.value).format('YYYY-MM-DD');
        }
        if (data && data.date_to && data.date_to.value) {
            toSend.date_to = moment(data.date_to.value).format('YYYY-MM-DD');
        }
        let item_based_condition = null;
        let item_based_discount = null;
        // El type va a decirdir que traza tomar para crear el objeto
        if (data.type.value === 'item_based') {
            item_based_condition = {}
            if (data && data.items_to_buy && data.items_to_buy.value) {
                // toSend.items_to_buy = data.items_to_buy.value.map((g) => +g.key);
                item_based_condition.items_to_buy = data.items_to_buy.value.map((g) => +g.key);
            }
            if (data && data.apply_when_buy && data.apply_when_buy.value) {
                // apply_when_buy
                // toSend.apply_when_buy = data.apply_when_buy.value;
                item_based_condition.apply_when_buy = data.apply_when_buy.value;
            }
            if (data && data.buy_type && data.buy_type.value) {
                // Puede ser any, each, combine
                // toSend.buy_type = data.buy_type.value;
                item_based_condition.buy_type = data.buy_type.value;
            }
            if (data && data.items_to_apply_count_option && data.items_to_apply_count_option.value) {
                // All, apply_first, skip_first (items_to_apply_count_option)
                // items_to_apply_count_option
                // toSend.items_to_apply_count_option = data.items_to_apply_count_option.value;
                item_based_condition.items_to_apply_count_option = data.items_to_apply_count_option.value;
            }
            if (data && data.items_to_apply_count && data.items_to_apply_count.value) {
                // cantidad de arriba
                // items_to_apply_count
                // toSend.items_to_apply_count = +data.items_to_apply_count.value;
                item_based_condition.items_to_apply_count = +data.items_to_apply_count.value;
            }
            // quantity_rule
            if (data && data.quantity_rule && data.quantity_rule.value) {
                // quantity_rule
                // toSend.quantity_rule = data.quantity_rule.value;
                item_based_condition.quantity_rule = data.quantity_rule.value;
            }
            if (data && data.quantity_from && data.quantity_from.value) {
                // cantidad de arriba
                // quantity_from, falta el quantity_to Habilitado si quantity_rule = from
                // toSend.quantity_from = +data.quantity_from.value;
                item_based_condition.quantity_from = +data.quantity_from.value;
            }
            if (data && data.quantity_to && data.quantity_to.value) {
                // cantidad de arriba
                // quantity_from, falta el quantity_to Habilitado si quantity_rule = from
                item_based_condition.quantity_to = +data.quantity_to.value;
            }
            if (data && data.apply_to && data.apply_to.value) {
                item_based_condition.apply_to = data.apply_to.value;
            }
            if (data && data.items_to_apply && data.items_to_apply.value) {
                item_based_condition.items_to_apply = data.items_to_apply.value.map((g) => +g.key);
            }
            if (data && data.discount_type && data.discount_type.value) {
                item_based_discount = { discount_type: '', discount_value: 0 }
                // discount_type
                // toSend.discount_type = data.discount_type.value;
                item_based_discount.discount_type = data.discount_type.value;
            }
            if (data && data.discount_value && data.discount_value.value) {
                // discount_value
                // toSend.discount_value = data.discount_value.value;
                item_based_discount.discount_value = data.discount_value.value;
            }
        }
        if (data.type.value === 'quantity_based') {
            if (data && data.apply_to && data.apply_to.value) {
                toSend.apply_to = data.apply_to.value;
            }
            toSend.items_to_apply = (data && data.items_to_apply && data.items_to_apply.value)
                ? data.items_to_apply.value.map((g) => +g.key)
                : [];

            toSend.default_discount = {
                discount_type: 'percentage',
                value: +simplePercentage,
            };

            toSend.custom_discounts = (customDiscounts || [])
                .filter((custom) => custom.selectedProducts && custom.selectedProducts.length > 0 && custom.discountKind)
                .map((custom) => {
                    if (custom.discountKind === 'percentage') {
                        return {
                            selected_products: custom.selectedProducts.map((p) => +p.id),
                            discount_kind: 'percentage',
                            percentage_value: +custom.percentageValue,
                        };
                    }
                    return {
                        selected_products: custom.selectedProducts.map((p) => +p.id),
                        discount_kind: 'range',
                        range_min: +custom.rangeMin,
                        range_max: +custom.rangeMax,
                        range_discount_type: custom.rangeDiscountType,
                        range_value: +custom.rangeValue,
                    };
                });
        }

        let discount_subsidiaries = [];
        if (data && data.subsidiarie_id && data.subsidiarie_id.value) {
            discount_subsidiaries = data.subsidiarie_id.value.map((g) => +g);
        }
        let discount_customer_type = [];
        if (data && data.customer_type_id && data.customer_type_id.value) {
            discount_customer_type = data.customer_type_id.value.map((g) => +g);
        }
        let active = false;
        if (data && data.active && data.active.value) {
              active =  data.active.value
        }
        toSend = {
            ...toSend,
            item_based_discount,
            item_based_condition,
            discount_customer_type,
            discount_subsidiaries,
            active
        }
        //
        // console.log('to send',toSend,data);
        // eslint-disable-next-line no-unused-vars, prefer-const
        let response = null;
        try {
            response = await API.patch(`/api/discounts/${data.id}`, toSend);
            // console.log('Response adentro del try catch: ', response);
        } catch (error) {
            let errorMessage = "Error al guardar!";
            if (error.response && error.response.data) {
                console.log('error response',error.response);
                errorMessage +=", "+error.response.data.message;
              }
            message.error(errorMessage)
        }
        this.setState({
            // eslint-disable-next-line react/no-unused-state
            isLoading: false,
        });
        // console.log('Estee es el response: ', response);
        if (response.status === 200) {
            // se guardo con exito
            message.success('Se guardo con exito!')
            setTimeout(() => {
                this.props.history.push('/discounts')
            }, 300);
        }
    }

    render() {
        const { classes } = this.props
        const { current, data } = this.state
        // eslint-disable-next-line prefer-const
        // let dataCloned = {
        //     ...data,
        //     apply_apply_to: data.apply_to,
        // }
        // delete dataCloned.apply_to;
        return (
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: 3,
                    padding: 16,
                }}
            >
                <Steps current={current}>
                    <Step title="General" />
                    <Step title="Condición" />
                    <Step title="Descuento" />
                </Steps>
                <div className={classes.stepsContent}>
                    {current === 0 && (
                        <WrappedRegistrationForm
                            {...data}
                            isLoading={this.state.isLoading}
                            onFieldChange={this.onFieldChange}
                            onCompleted={() => this.next()}
                            history={this.props.history}
                        />
                    )}

                    {current === 1 && (
                        <DiscountsConditionForm
                            isLoading={this.state.isLoading}
                            {...this.state.data}
                            // {...dataCloned}
                            onFieldChange={this.onFieldChange}
                            onCompleted={() => this.next()}
                        />
                    )}

                    {current === 2 && (
                        <DiscountsDiscountForm
                            {...data}
                            onFieldChange={(changedFields) => {
                                // console.log('changedFields: ', changedFields);
                                if (this.onFieldChange) {
                                    this.onFieldChange(changedFields);
                                }
                            }}
                            isLoading={this.state.isLoading}
                            simplePercentage={this.state.simplePercentage}
                            customDiscounts={this.state.customDiscounts}
                            onDiscountsChange={(changes) => this.setState(changes)}
                            onCompleted={() => this.next()}
                            // onFieldChange={this.onFieldChange}
                            // eslint-disable-next-line react/jsx-closing-bracket-location
                        />
                    )}
                </div>
                <div className="steps-action">
                    {/* {current < steps.length - 1 && (
						<Button type="primary" onClick={() => this.next()}>
							Next
						</Button>
					)} */}
                    {/* {current === steps.length - 1 && (
                        <Button type="primary" onClick={() => message.success('Processing complete!')}>
                            Done
                        </Button>
                    )} */}
                    {current > 0 && (
                        <Button
                            style={{ marginLeft: 8 }}
                            onClick={() => this.prev()}
                            disabled={this.state.isLoading}
                            loading={this.state.isLoading}
                        >
                            Regresar
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}

export default injectSheet(styles)(DiscountsEditContainer)
